import { DispatchedAction, DispatchedAsyncAction } from "../../../types/actions";

import {
	GenerateMagicLinksForEvent,
	GenerateMagicLinksForList,
	GetMagicLinksForEvent,
	InvalidateMagicLinksForEvent,
	InvalidateMagicLinksForEventV2,
} from "../../../connection/magic-links";
import type { AudienceMagicLink, MergedAudienceMember } from "@/types/audience-list-members.types";

export const GET_MAGIC_LINKS_FOR_EVENT = "GET_MAGIC_LINKS_FOR_EVENT";
type GetMagicLinksForEventAction = DispatchedAsyncAction<
	typeof GET_MAGIC_LINKS_FOR_EVENT,
	Awaited<ReturnType<typeof GetMagicLinksForEvent>>
>;
export function getMagicLinksForEvent(token: string, channel: number, list_id: number, event_uuid: string): GetMagicLinksForEventAction {
	return {
		type: GET_MAGIC_LINKS_FOR_EVENT,
		promise: GetMagicLinksForEvent(token, channel, list_id, event_uuid)
	};
}

export const GENERATE_MAGIC_LINKS_FOR_EVENT = "GENERATE_MAGIC_LINKS_FOR_EVENT";
type GenerateMagicLinksForEventAction = DispatchedAsyncAction<
	typeof GENERATE_MAGIC_LINKS_FOR_EVENT,
	Awaited<ReturnType<typeof GenerateMagicLinksForEvent>>
>;
export function generateMagicLinksForEvent(token: string, channel: number, list_id: number, event_uuid: string, passcode_list_type: number, selectedMembers?: MergedAudienceMember[], forceAllowDuplicate = false): GenerateMagicLinksForEventAction {
	return {
		type: GENERATE_MAGIC_LINKS_FOR_EVENT,
		promise: GenerateMagicLinksForEvent(token, channel, list_id, event_uuid, passcode_list_type, selectedMembers, forceAllowDuplicate)
	};
}

export const GENERATE_MAGIC_LINKS_FOR_LIST = "GENERATE_MAGIC_LINKS_FOR_LIST";
type GenerateMagicLinksForListAction = DispatchedAsyncAction<
	typeof GENERATE_MAGIC_LINKS_FOR_LIST,
	Awaited<ReturnType<typeof GenerateMagicLinksForList>>
>;
export function generateMagicLinksForList(token: string, channel: number, list_id: number, eventReturnFilter?: string): GenerateMagicLinksForListAction {
	return {
		type: GENERATE_MAGIC_LINKS_FOR_LIST,
		promise: GenerateMagicLinksForList(token, channel, list_id, eventReturnFilter),
	};
}

export const INVALIDATE_MAGIC_LINKS_FOR_EVENT = "INVALIDATE_MAGIC_LINKS_FOR_EVENT";
type InvalidateMagicLinksForEventAction = DispatchedAsyncAction<
	typeof INVALIDATE_MAGIC_LINKS_FOR_EVENT,
	Awaited<ReturnType<typeof InvalidateMagicLinksForEvent | typeof InvalidateMagicLinksForEventV2>>
>;
export function invalidateMagicLinksForEvent(token: string, channel: number, list_id: number, event_uuid: string, member_ids?: number[]): InvalidateMagicLinksForEventAction {
	return {
		type: INVALIDATE_MAGIC_LINKS_FOR_EVENT,
		promise: InvalidateMagicLinksForEvent(token, channel, list_id, event_uuid, member_ids)
	};
}

export function invalidateMagicLinksForEventV2(token: string, channel: number, list_id: number, event_uuid: string, member_ids?: number[]): InvalidateMagicLinksForEventAction {
	return {
		type: INVALIDATE_MAGIC_LINKS_FOR_EVENT,
		promise: InvalidateMagicLinksForEventV2(token, channel, list_id, event_uuid, member_ids)
	};
}

export const SET_MAGIC_LINKS_FOR_EVENT_SYNC = 'SET_MAGIC_LINKS_FOR_EVENT_SYNC';
type SetMagicLinksForEventSyncAction = DispatchedAction<
	typeof SET_MAGIC_LINKS_FOR_EVENT_SYNC,
	{
		members: AudienceMagicLink[]
	}
>;
export function setMagicLinksForEventSync(links: AudienceMagicLink[]): SetMagicLinksForEventSyncAction {
	return {
		type: SET_MAGIC_LINKS_FOR_EVENT_SYNC,
		payload: { members: links }
	};
}

export type MagicLinksAction =
	GetMagicLinksForEventAction |
	GenerateMagicLinksForEventAction |
	GenerateMagicLinksForListAction |
	InvalidateMagicLinksForEventAction |
	SetMagicLinksForEventSyncAction;
